@if (edit == true) {
  <div class="row">
    <div class="col-12">
      <h3 style="float: left;">Zones</h3>
      <!-- <div style="float: right;">
      <button mat-raised-button class="pad-btn" title="Add Strain" (click)="addStrain()">
        <mat-icon aria-hidden="false" aria-label="Add Strain">add</mat-icon>
      </button>
    </div> -->
  </div>
</div>
}

<div class="row">
  <div class="col-sm-12">
    @if (edit == true) {
      <div class="row">
        <div class="col-12" style="padding-bottom: 10px;">
          <div style="float: right;">
            @if (canSeeLeaflogix) {
              <button mat-raised-button class="pad-btn" [disabled]="refreshingZones" title="Refresh Zones" (click)="refreshZonesClick()">
                @if (refreshingZones) {
                  <i class="fa fa-spinner fa-spin"></i>
                }
                @if (!refreshingZones) {
                  <span>Sync with Dutchie</span>
                }
              </button>
            }
            <button class="gridbtn" mat-raised-button (click)="setGroups()" title="Add Zone">
              Set Zone Groups
            </button>
            @if (zoneObject?.zoneTitles?.length > 0) {
              <button class="gridbtn" mat-raised-button (click)="addZone()" title="Add Zone">
                <mat-icon aria-hidden="false" aria-label="Add Zone">add</mat-icon>
              </button>
            }
            <button class="gridbtn" mat-raised-button [disabled]="!dirty" (click)="save()" title="Save Zone">
              @if (saving) {
                <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
              }
              @if (!saving) {
                <mat-icon aria-hidden="false" aria-label="Save Zone">save</mat-icon>
              }
            </button>
            <button class="gridbtn" mat-raised-button [disabled]="!dirty" (click)="get()" title="Undo">
              <mat-icon aria-hidden="false" aria-label="Undo">undo</mat-icon>
            </button>
            <button mat-button (click)="info()">
              <mat-icon>info</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
    @if (edit == false) {
      <div class="row sticky-header" style="padding-bottom: 10px;">
        @for (s of strains; track s) {
          <div class="col-sm-3">
            {{s.strainName}}: {{getPlacementCountForStrain(s)}}/{{s.count}}
          </div>
        }
      </div>
    }
    @if (edit == true && zoneObject?.zoneTitles?.length == 0) {
      <div class="row" style="padding-bottom: 10px;">
        <div class="col-12">
          <app-zone-explanation></app-zone-explanation>
        </div>
      </div>
    }
    @if (zoneObject?.zoneTitles?.length > 0) {
      <div class="row">
        <div class="col-12">
          <table class="fixed_header">
            <tr class="table_header">
              @for (col of columns; track col) {
                <th>{{col.headerName}}</th>
              }
            </tr>
            @for (row of zoneDisplays; track row) {
              <tr class="table_body" [style.border-top]="borderTopStyle(row)">
                @if (edit == true) {
                  @for (col of columns; track col) {
                    <td [class.editable-cell]="class(row[col.field])" (click)="zoneClick(row[col.field])">
                      @if (row[col.field] != null) {
                        <span>{{row[col.field].name}} <span style="font-size: 14px; color: #43a047">({{row[col.field].placements}})</span></span>
                      }
                    </td>
                  }
                }
                @if (edit == false) {
                  @for (col of columns; track col; let i = $index) {
                    <td>
                      @if (row[col.field] != null) {
                        <mat-checkbox style="margin-right: 10px;" [ngModel]="row[col.field].checked" (ngModelChange)="checkChange(row[col.field], i, $event)">{{row[col.field].name}} <span style="font-size: 14px;">({{row[col.field].placements}})</span></mat-checkbox>
                        @if (row[col.field].checked) {
                          <div style="display: inline-block;">
                            @for (strain of row[col.field].strains; track strain) {
                              <div style="display: flex;">
                                <mat-form-field style="flex: 40%;">
                                  <mat-select [(ngModel)]="strain.id">
                                    @for (s of strains; track s) {
                                      <mat-option [value]="s.strainId">
                                        {{ s.strainName }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field style="flex: 20%; max-width: 75px">
                                  <input matInput type="number" [(ngModel)]="strain.count" (ngModelChange)="countValueChange(row[col.field].strains, strain, $event, row[col.field].placements)">
                                </mat-form-field>
                                @if (row[col.field].strains.length < strains.length) {
                                  <button type="button" mat-icon-button style="flex: 20%;" (click)="add(row[col.field].strains, row[col.field].placements)" title="Add Strain">
                                    <mat-icon>add</mat-icon>
                                  </button>
                                }
                                @if (row[col.field].strains.length > 1) {
                                  <button type="button" mat-icon-button style="flex: 20%;" (click)="remove(row[col.field].strains, strain)" title="Remove Strain">
                                    <mat-icon>remove</mat-icon>
                                  </button>
                                }
                              </div>
                            }
                          </div>
                        }
                      }
                    </td>
                  }
                }
              </tr>
            }
          </table>
          <!-- <ag-grid-angular
          style="width: 100%; min-height:400px; height: calc(100vh - 300px);"
          class="ag-theme-balham"
          [gridOptions]="gridOptions"
          [rowData]="zoneDisplays"
          [columnDefs]="columns"
          (selectionChanged)="onSelectionChanged()">
        </ag-grid-angular> -->
      </div>
    </div>
  }
</div>
<!-- <div class="col-sm-6">
<div class="row">
  <div class="col-12" style="padding-bottom: 10px;">
    <div style="float: right;">
      <button class="gridbtn" mat-raised-button *ngIf="zone != null" (click)="save()" title="Save Zone">
        <mat-icon aria-hidden="false" aria-label="Save Zone">save</mat-icon>
      </button>
      <button class="gridbtn" mat-raised-button *ngIf="zone != null" (click)="getAll()" title="Undo">
        <mat-icon aria-hidden="false" aria-label="Undo">undo</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="row" *ngIf="zone != null">
  <div class='col-12'>
    <mat-form-field>
      <input matInput class="zone-name" [(ngModel)]="zone.name" placeholder="Name">
    </mat-form-field>
  </div>
</div>
</div> -->
</div>
